module.exports = __webpack_public_path__ + "static/img/SoftwareSupportDetail_content.3f4a6515.png";